export enum ChatInfoButtons {
  ALL_ATTACHMENTS = 'allAttachments',
  IMAGES = 'images',
  PARTICIPANTS = 'participants',
  NOTIFICATIONS = 'notifications',
  GENERIC = 'generic'
}

export enum ChatInfoActions {
  LEAVE = 'leave',
  INVITE = 'invite',
  HIDE = 'hide'
}
